import React, { useState, useEffect } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { track } from "../../../utils/analytics";

import WaitingListTable from "./WaitingListTable";
import PreapprovalTable from "./PreapprovalTable";

const renderPageSelector = ({ filter, users = [], setFilter, count }) => {
  // const waitlistUserCount =
  //   filter === "waitlist"
  //     ? count || (users || []).filter(checkWaitlingList).length
  //     : null;
  // const preappovalUserCount =
  //   filter === "preapprovals"
  //     ? count || (users || []).filter(checkPreapprovals).length
  //     : null;
  return (
    <div className="">
      <span
        id="waitlist"
        className="cursor-pointer p-2"
        onClick={e => setFilter(e.target.id)}
      >
        {/* {`Waiting List${waitlistUserCount ? ` (${waitlistUserCount})` : ""}`} */}
        {`Waiting List${filter === "waitlist" ? ` (${count})` : ""}`}
      </span>
      |
      <span
        id="preapprovals"
        className="cursor-pointer p-2"
        onClick={e => setFilter(e.target.id)}
      >
        {/* {`Preapprovals ${
          preappovalUserCount ? ` (${preappovalUserCount})` : ""
        }`} */}
        {`Preapprovals${filter === "preapprovals" ? ` (${count})` : ""}`}
      </span>
    </div>
  );
};

// const checkWaitlingList = u =>
//   !["approved", "rejected"].includes(u.application_status) && u.is_waitlisted;
// const checkPreapprovals = u =>
//   !["approved", "rejected"].includes(u.application_status) &&
//   u.application &&
//   u.application.is_preapproved != null;
//
// const filterData = (pg, users) => {
//   console.log("filtering data with pg", pg);
//   console.log("users:", users.length);
//   switch (pg) {
//     case "waitlist":
//       return users.filter(checkWaitlingList);
//     case "preapprovals":
//       return users.filter(checkPreapprovals);
//     case "customersupport":
//       return [];
//     default:
//       return [];
//   }
// };

const Admin = () => {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("unselected");
  const [sort, setSort] = useState("created_at");
  const [order, setOrder] = useState("DESC");
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(20);
  const [count, setCount] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [pageList, setPageList] = useState([]);

  const client = useApolloClient();

  const update = d => {
    console.log("updating");
    // const filteredData = filterData(filter, d || []);
    setPageList(d || []);
  };

  const fetch = async () => {
    console.log("fetching");
    setLoading(true);
    const results = await client.query({
      query: ADMIN_USERS_QUERY,
      variables: {
        page,
        size,
        search,
        filter,
        sort,
        order
      }
    });
    setLoading(false);

    const { data: { adminUsers } = {} } = results || {};
    const { users, summary: { total_count } = {} } = adminUsers || {};
    if (users) {
      setData(users);
    }
    if (total_count) {
      setCount(total_count);
    } else {
      console.log("No total_count returned from API, using fallback");
      setCount((users || []).length);
    }
  };

  useEffect(() => {
    fetch();
  }, [filter, page]);

  useEffect(() => {
    if (page === 0) fetch();
    else setPage(0);
  }, [search]);

  useEffect(() => {
    update(data);
  }, [data]);

  // track("DASHBOARD_LOADED_ADMIN");

  const handleSort = column => {
    const { id } = column;
    console.log("handleSort column", column);
  };

  const handleSearch = query => {
    console.log("handleSearch query", query);
    setSearch(query);
  };

  const handleNextPage = () => {
    console.log("handleNextPage");
    setPage(page + 1);
  };

  const handlePreviousPage = () => {
    console.log("handlePreviousPage");
    setPage(page - 1);
  };

  const renderPage = ({
    filter: f,
    data: d,
    count: c,
    size: s,
    search: se
  }) => {
    let Component;
    switch (f) {
      case "waitlist":
        Component = WaitingListTable;
        break;
      case "preapprovals":
        Component = PreapprovalTable;
        break;
      case "unselected":
        return <div className="m-2">Please select a section to view.</div>;
      default:
        return <div className="m-2">Unknown State</div>;
    }

    const pageCount = Math.ceil(c / s);

    return (
      <Component
        className=""
        users={d}
        handleSort={handleSort}
        handleSearch={handleSearch}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        pageIndex={page}
        pageCount={pageCount}
        initialSearchQuery={se}
      />
    );
  };

  return error ? (
    <>Error...</>
  ) : loading ? (
    <>Loading...</>
  ) : (
    <div className="admin-page">
      {renderPageSelector({
        users: data,
        filter,
        setFilter,
        setPageList,
        count
      })}
      {renderPage({ filter, data: pageList, count, size, search })}
    </div>
  );
};

const ADMIN_USERS_QUERY = gql`
  query AdminUsers(
    $page: Int
    $size: Int
    $search: String
    $filter: String
    $sort: String
    $order: String
  ) {
    adminUsers(
      page: $page
      size: $size
      search: $search
      filter: $filter
      sort: $sort
      order: $order
    ) {
      users {
        email
        first_name
        last_name
        application_status
        created_at
        is_waitlisted
        phone_number
        api_type
        aggregator_type
        application {
          waitlist_position
          is_preapproved
          age
          has_ssn
          full_name
          total_monthly_income
          total_account_balances
          min_limit
          max_limit
        }
        referrers {
          sender_email
        }
      }
      summary {
        total_count
      }
    }
  }
`;

export default Admin;
